export default __webpack_public_path__ + "static/media/Icon_Filter.ec2ec3b7.png";